import {
  React,
  Component,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  SecondaryButton,
  PrimaryButton,
  SignDialog,
  AlertDialogOneButton,
  LoadingDialog,
} from 'imports/DesignImports';

import {CircularProgress} from 'material-ui';

export default class SignButtonComponent extends Component {
  state = {
    error: false,
    loading: true,
    signDialog: false,
    alertDialogOneButton: false,
    loadingDialog: false,
  }

  componentDidMount(){
    this.getSignatureStatus();
  }

  render(){
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center'}}>
          Error
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <CircularProgress color='#9e9e9e' size={25} thickness={2} />
          </div>
      )
    }
    return(
      <div>
        {this.getButton()}
        { this.state.signDialog ? <SignDialog sign={this.sign} cancel={() => this.setState({signDialog: false})} projectId={this.props.project.id}/> : null }
        { this.state.loadingDialog ? <LoadingDialog message="Estamos enviando los datos, espera un momento" /> : null }
        { this.state.alertDialogOneButton ?
          <AlertDialogOneButton
            title={this.state.alertTitle}
            message={this.state.alertMessage}
            acceptLabel={this.state.acceptLabel}
            confirm={this.state.confirm}/> : null}
      </div>
    );
  }

  getButton = () => {
    let project = this.props.project
    if(project.state.length > 0 && project.state[0].state === "En proceso de firma" && this.state.signature.decision === 'next'){
      return (
        <SecondaryButton
          label="Firmar"
          style={this.props.style || {width: '6em'}}
          onClick={(event) => {event.stopPropagation(); this.setState({signDialog: true})}}/>
      );
    }
    if (project.state.length > 0 && project.state[0].state === "En proceso de firma" && this.state.signature.decision === 'signed') {
      return (
        <PrimaryButton
          disabled={true}
          label="Firmado"
          style={this.props.style || {width: '6em'}} />
      );
    }
    return (
      <PrimaryButton
        disabled={true}
        label="Aún no debes firmar"
        style={this.props.style || {width: '12em'}} />
    );
  }

  getSignatureStatus = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.token}
    });
    connection.get(routes.signature(this.props.project.id, this.props.user.id))
    .then((response) => {
      this.setState({
        signature: response.data,
        loading: false,
      })
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        loading: false,
        error: true,
      })
    });
  }

  sign = (decision, justification) => {
    this.setState({loadingDialog: true})
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.token}
    });
    let data = {
      decision: decision,
      justification: justification,
    }
    connection.post(routes.signProject(this.props.project.id), data)
    .then((response) => {
      this.raiseOneButtonAlert('¡Felicidades!', 'Tu decisión sobre el proyecto ha sido enviada', 'Aceptar', () => {this.setState({alertDialogOneButton: false, signDialog: false}); window.location.reload()})
      this.setState({project: null, loadingDialog: false});
    })
    .catch((error) => {
      console.log(error);
      this.raiseOneButtonAlert('¡Atención!', 'Hubo un problema al enviar tu decisión, por favor intenta nuevamente', 'Aceptar', () => this.setState({alertDialogOneButton: false, signDialog: false}))
      this.setState({project: null, loadingDialog: false});
    });
  }

  raiseOneButtonAlert = (title, message, acceptLabel, confirm) => {
    this.setState({alertDialogOneButton: true, alertTitle: title, alertMessage: message, acceptLabel: acceptLabel, confirm: confirm})
  }
}



// WEBPACK FOOTER //
// ./src/components/files/SignButtonComponent.js